<breadcrumb [endText]="endText" [navigations]="breadcrumbNav" />

@if (showAddStudent) {
  <div class="fixed inset-0 bg-gray-600 bg-opacity-60 z-30 flex items-center justify-center">
    <div class="bg-white rounded-lg p-4 w-fit max-w-[50%]">
      <div class="flex justify-between items-center mb-3 text-[#4B5563] border-b border-[#E3E3E3] pb-4 mb-4">
        <div class="mr-10">
          <span class="font-semibold">Add Student</span><br/>
          Add a new student to this subsection
        </div>
        <button (click)="showAddStudent = false; student_to_add_netid = ''" class="p-1.5 w-10 h-10 rounded-full hover:bg-gray-200 flex items-center justify-center">
          <fa-icon [icon]="faXmark" />
        </button>
      </div>
      <div class="gap-y-2 text-[#4B5563]">
        <div>Student's NetID:</div>
        <input [(ngModel)]="student_to_add_netid" type="text" class="input w-full mb-4" placeholder="Type here..." />
      </div>
      <div class="flex justify-end mt-3">
        <outline-button (click)="showAddStudent = false; student_to_add_netid = ''" text="Cancel" />
        <full-button (click)="addStudentToSubsection()" text="Add Student" />
      </div>
    </div>
  </div>
}

@if(confirmDeleteStudent) {
  <div class="fixed inset-0 bg-gray-600 bg-opacity-60 z-30 flex items-center justify-center">
    <div class="bg-white rounded-lg p-4 w-fit max-w-[400px]">
      <div class="flex justify-between items-center mb-3 text-[#4B5563] pb-4 mb-4">
        <div class="text-center">
          Are you sure you want to remove this student from this subsection?
        </div>
      </div>
      <div class="flex justify-end mt-3">
        <outline-button (click)="confirmDeleteStudent = false; student_id_to_delete = -1" text="Cancel" />
        <full-button (click)="removeStudentFromSubsection()" text="Confirm" />
      </div>
    </div>
  </div>
}

<div class="pl-16 pr-10 pt-14 pb-4">
  <div class="self-stretch justify-start text-neutral-950 text-3xl font-semibold leading-10">
    Students for {{subsection_name}}
  </div>
  <div class="my-5 flex w-full justify-between items-center">
    <div class="flex gap-2 items-center">
      <div class="w-80 h-12 py-[10px] px-[16px] h-[48px] rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-400/50 inline-flex justify-start items-center gap-3 bg-white">
        <fa-icon [icon]="faMagnifyingGlass" class="text-[#637381]" />
        <input (ngModelChange)="debounceSearch()" class=".placeholder-[#586674] bg-transparent !outline-none flex-grow h-full" placeholder="Search..." [(ngModel)]="searchText"/>
      </div>
      <dot-spinner [isLoading]="isLoading"></dot-spinner>
    </div>
    <full-button [faIcon]="faUserPlus" text="Add Student" (click)="showAddStudent = true" />
  </div>
  <div class="grid grid-cols-4 rounded-t-[8px] bg-[#E2E8F0] rounded-md overflow-hidden h-[64px] w-full">
    <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
      Name
    </div>
    <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
      NetID
    </div>
    <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
      Email
    </div>
    <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
      Actions
    </div>
  </div>
  @if (!isLoading) {
    @for (student of students ; track student.user_id; let i = $index) {
      <div [ngClass]="i % 2 === 0? 'rounded-md grid grid-cols-4 overflow-hidden h-[64px] w-full': 'bg-[#F3F6F9] rounded-md grid grid-cols-4 overflow-hidden h-[64px] w-full'">
        <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
          {{student.display_name}}
        </div>
        <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
          {{student.username}}
        </div>
        <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
          {{student.email}}
        </div>
        <div class="flex gap-[8px] items-center mx-[12px]">
          <button (click)="seeStudentProfile(student.email)" aria-label="Student profile" tooltip="Profile">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke="#637381" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button (click)="confirmDeleteStudent = true; student_id_to_delete = student.user_id" aria-label="Remove student from subsection" tooltip="Remove student">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#CC0033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    }
  } @else {
    @for (i of [1, 2, 3]; track i) {
      <div class="bg-gray-100 animate-pulse rounded-md h-[63px] w-full mt-[3px]"></div>
    }
  }
</div>
